import { Theme } from '@mui/material';


const Avatar = (theme: Theme) => {
  return {
    MuiAvatar: {
      variants: [
        {
          props: { variant: 'rounded' },
          style: {
            borderRadius: '12px',
          },
        },
      ],
    },
  };
};

export default Avatar;
